'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _PropTypes = require('../utils/lib/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getImageSrc = function getImageSrc(imageId, ichefBasePath) {
  return (/^http/.test(imageId) ? imageId : ichefBasePath + 'images/ic/608xn/' + imageId + '.jpg'
  );
};

var Promo = function Promo(_ref) {
  var className = _ref.className,
      gelColumns = _ref.gelColumns,
      ichefBasePath = _ref.ichefBasePath,
      imageId = _ref.imageId,
      title = _ref.title,
      synopsis = _ref.synopsis,
      url = _ref.url;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)('ec-promo', 'gel-layout--item', 'gel-' + gelColumns + '/12', className) },
    _react2.default.createElement(
      'a',
      { href: url, className: 'ec-promo__link' },
      _react2.default.createElement(
        'div',
        { className: 'ec-promo__image-container' },
        _react2.default.createElement(
          'div',
          { className: 'ec-promo__image-container__16/9' },
          _react2.default.createElement('img', {
            className: 'ec-promo__image',
            'data-class': 'ec-promo__image',
            src: getImageSrc(imageId, ichefBasePath),
            alt: ''
          })
        )
      ),
      _react2.default.createElement(
        'div',
        { className: 'ec-promo__text-container' },
        _react2.default.createElement(
          'div',
          { className: 'ec-promo__text' },
          _react2.default.createElement(
            'h3',
            { className: 'ec-promo__title' },
            title
          ),
          _react2.default.createElement(
            'p',
            { className: 'ec-promo__synopsis' },
            synopsis
          )
        )
      )
    )
  );
};

Promo.propTypes = {
  className: _PropTypes2.default.string,
  gelColumns: _PropTypes2.default.number,
  ichefBasePath: _PropTypes2.default.string.isRequired,
  imageId: _PropTypes2.default.string.isRequired,
  title: _PropTypes2.default.string.isRequired,
  synopsis: _PropTypes2.default.string,
  url: _PropTypes2.default.string.isRequired
};

Promo.defaultProps = {
  className: '',
  gelColumns: 12
};

exports.default = Promo;